import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { Workspace } from 'honeygrid-types'

import { dataSourcesQueryKey } from './useDataSources'

/**
 * Delete a data source by id.
 * Automatically invalidates the workspace data-source list on success.
 */
export const useDeleteDataSource = (workspaceId?: Workspace['uuid']) => {
	const authFetch = useHoneyGridApiFetch()
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async (dataSourceId: string) =>
			authFetch(`workspaces/${workspaceId}/data-sources/${dataSourceId}`, {
				method: 'DELETE',
			}),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: dataSourcesQueryKey(workspaceId) })
		},
	})
}
